import { format, getTime, formatDistanceToNow } from 'date-fns';

// ----------------------------------------------------------------------

export function fDate(date, newFormat) {
	const fm = newFormat || 'dd MMM yyyy';

	return date ? format(new Date(date), fm) : '';
}

export function fDateTime(date, newFormat) {
	const fm = newFormat || 'dd MMM yyyy p';

	return date ? format(new Date(date), fm) : '';
}

// export function fTimestamp(date) {
//   return date ? getTime(new Date(date)) : '';
// }

export function fTimestamp(date, startOfDay = false, endOfDay = false) {
	if (!date) return '';
	const d = new Date(date);

	if (endOfDay) {
		d.setHours(23, 59, 59, 999);
	}
	if (startOfDay) {
		d.setHours(0, 0, 0, 0);
	}

	return getTime(d);
}


export const formatDate = (dateString) => {
	const date = new Date(dateString);
	if (isNaN(date)) return '';
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');
	const year = date.getFullYear();
	let hours = date.getHours();
	const minutes = String(date.getMinutes()).padStart(2, '0');
	const ampm = hours >= 12 ? 'PM' : 'AM';
	hours = hours % 12 || 12;
	return `${month}/${day}/${year} ${hours}:${minutes} ${ampm}`;
};

export function fToNow(date) {
	return date
		? formatDistanceToNow(new Date(date), {
			addSuffix: true,
		})
		: '';
}



